const ambiente = {
    ...(window.__ENV__ || {})
};

export default ambiente;